import { PATH_API } from "./api";

export const DISABLE_SW_HEADER_KEY = "disable-sw";
export const BUNDLE_FILES_CACHE = "neptune-bundle-files";
export const STYLE_FILES_CACHE = "neptune-style-files";
export const S3_FILES_CACHES = "neptune-s3-files";
export const OTHER_STATIC_FILES_CACHE = "neptune-other-static-files";
export const THIRD_PARTY_FILES_CACHES = "neptune-third-party-files";
export const API_GET_CACHE = "neptune-api-cache";
export const SERVER_ORIGIN = (process.env.REACT_APP_API_HOST_URL || "").slice(
  0,
  (process.env.REACT_APP_API_HOST_URL || "").lastIndexOf("/new-api")
);

export const LIST_PATH_API_CACHE_FIRST = ["autodesk.com/"];

export const API_HOST_PREFIX = (process.env.REACT_APP_API_HOST_URL || "")
  .split("/")
  .pop();

export const API_SKIP_TO_CACHE = ["https://api-js.mixpanel.com/track"];

export const API_GET_BY_POST = [
  "/refreshToken",
  "/refresh-token",
  "https://api-js.mixpanel.com/track",
  "cdn.tiny.cloud",
  "/s3-presigned-url",
  "/check-s3-file-exist",
  "/object-metadata",
];

export const CACHE_QUERY_PARAM = "shouldCache";

export const PROJECT_DATA_CACHE_PROGRESS_STORE =
  "project-data-cache-progress-store";
export const NETWORK_STORE = "network-store";
export const NETWORK_STORE_KEY = "status";
export const FILE_STORE = "file-store";
export const DATA_STORE = "data-store";
export const PROJECT_CACHE_V2 = "project-cache-v2";

export enum StoreName {
  "TASK_TYPES" = "task-types",
  "DOCUMENT_CATEGORIES" = "document-categories",
  "BLACKBOARDS" = "blackboards",
  "SUB_ITEMS" = "sub-items",
  "DOCUMENT_ITEMS" = "document-items",
  "TASKS" = "tasks",
  "TASK_COMMENTS" = "task-comments",
  "DATA_LOGS" = "data-logs",
  "DOCUMENTS" = "documents",
  "DOCUMENT_KEYNOTES" = "document-keynotes",
  "DOCUMENT_TASKS" = "document-tasks",
  "USER_SETTINGS" = "user-settings",
  "DOCUMENT_GROUPS" = "document-groups",
  "BIM_FILES" = "bim-files",
  "DOCUMENT_TEMPLATES" = "document-templates",
  "FAMILIES" = "families",
  "TASK_SHEET_TEMPLATE" = "task-sheet-templates",
  "INSPECTION_CONTENT" = "inspection-content",
  "INSPECTION_ITEM" = "inspection-item",
  "INSPECTION_ITEM_RESULT" = "inspection-item-result",
  "INSPECTION_TYPE" = "inspection-type",
  "INSPECTION_PIN" = "inspection-pin",
  "INSPECTION_GROUP" = "inspection-group",
  "INSPECTION_PIN_CONTENT" = "inspection-pin-content",
  "INSPECTION_PIN_GROUP" = "inspection-pin-group",
  "INSPECTION_INSTANCES" = "inspections-instances",
  "INSPECTION_TARGETS" = "inspections-targets",
  "BIM_VIEWS" = "bims-views",
  "DOCUMENT_FORMATS" = "documents-formats",
  "DOCUMENT_PAGE_COMPONENTS" = "documents-page-components",
  "DOCUMENT_PAGE_LAYOUTS" = "documents-page-layouts",
  "DOCUMENT_PIN_COMPONENTS" = "documents-pin-components",
  "DOCUMENT_PIN_LAYOUTS" = "documents-pin-layouts",
  "DOCUMENT_COMPONENTS" = "document-components",
  "AREAS" = "areas",
  "BLACKBOARD_TEMPLATES" = "blackboard-templates",
  "CACHES" = "caches",
  "FILTERS" = "filters",
  "FORGES" = "aps-projects",
  "PARTNER_COMPANIES" = "partner-companies",
  "PROJECTS" = "projects",
  "S3" = "s3",
  "USERS" = "users",
  "BLACKBOARD_FORMAT" = "blackboard-format",
  "BLACKBOARD_FRAME" = "blackboard-frame",
  "PIN_CONTENT_IMAGE" = "pin-content-image",
}

export const MapApiWithStoreName = {
  [PATH_API.INSPECTION_GROUP]: StoreName.INSPECTION_GROUP,
  [PATH_API.INSPECTION_CONTENT]: StoreName.INSPECTION_CONTENT,
  [PATH_API.INSPECTION_ITEM]: StoreName.INSPECTION_ITEM,
  [PATH_API.INSPECTION_ITEM_RESULT]: StoreName.INSPECTION_ITEM_RESULT,
  [PATH_API.INSPECTION_TYPE]: StoreName.INSPECTION_TYPE,
  [PATH_API.INSPECTION_PIN]: StoreName.INSPECTION_PIN,
  [PATH_API.INSPECTION_PIN_CONTENT]: StoreName.INSPECTION_PIN_CONTENT,
  [PATH_API.INSPECTION_PIN_GROUP]: StoreName.INSPECTION_PIN_GROUP,
  [PATH_API.INSPECTION_INSTANCE]: StoreName.INSPECTION_INSTANCES,
  [PATH_API.INSPECTION_TARGET]: StoreName.INSPECTION_TARGETS,
  [PATH_API.SUB_ITEMS]: StoreName.SUB_ITEMS,
  [PATH_API.BIM_FILES]: StoreName.BIM_FILES,
  [PATH_API.USER_SETTINGS]: StoreName.USER_SETTINGS,
  [PATH_API.BIM_VIEW]: StoreName.BIM_VIEWS,
  [PATH_API.DOCUMENT_FORMAT]: StoreName.DOCUMENT_FORMATS,
  [PATH_API.DOCUMENT_PAGE_COMPONENT]: StoreName.DOCUMENT_PAGE_COMPONENTS,
  [PATH_API.DOCUMENT_PAGE_LAYOUT]: StoreName.DOCUMENT_PAGE_LAYOUTS,
  [PATH_API.DOCUMENT_PIN_COMPONENT]: StoreName.DOCUMENT_PIN_COMPONENTS,
  [PATH_API.DOCUMENT_PIN_LAYOUT]: StoreName.DOCUMENT_PIN_LAYOUTS,
  [PATH_API.DOCUMENT]: StoreName.DOCUMENTS,
  [PATH_API.AREA]: StoreName.AREAS,
  [PATH_API.BLACKBOARD]: StoreName.BLACKBOARDS,
  [PATH_API.BLACKBOARD_TEMPLATE]: StoreName.BLACKBOARD_TEMPLATES,
  [PATH_API.CACHE]: StoreName.CACHES,
  [PATH_API.DATA_LOG]: StoreName.DATA_LOGS,
  [PATH_API.DOCUMENT_CATEGORY]: StoreName.DOCUMENT_CATEGORIES,
  [PATH_API.DOCUMENT_COMPONENT]: StoreName.DOCUMENT_COMPONENTS,
  [PATH_API.DOCUMENT_GROUP]: StoreName.DOCUMENT_GROUPS,
  [PATH_API.DOCUMENT_ITEM]: StoreName.DOCUMENT_ITEMS,
  [PATH_API.DOCUMENT_KEYNOTE]: StoreName.DOCUMENT_KEYNOTES,
  [PATH_API.DOCUMENT_TASK]: StoreName.DOCUMENT_TASKS,
  [PATH_API.DOCUMENT_TEMPLATE]: StoreName.DOCUMENT_TEMPLATES,
  [PATH_API.FILTER]: StoreName.FILTERS,
  [PATH_API.FORGE]: StoreName.FORGES,
  [PATH_API.PARTNER_COMPANY]: StoreName.PARTNER_COMPANIES,
  [PATH_API.PROJECT]: StoreName.PROJECTS,
  [PATH_API.S3]: StoreName.S3,
  [PATH_API.TASK]: StoreName.TASKS,
  [PATH_API.TASK_COMMENT]: StoreName.TASK_COMMENTS,
  [PATH_API.TASK_SHEET_TEMPLATE]: StoreName.TASK_SHEET_TEMPLATE,
  [PATH_API.TASK_TYPE]: StoreName.TASK_TYPES,
  [PATH_API.USER]: StoreName.USERS,
  [PATH_API.FAMILY]: StoreName.FAMILIES,
  [PATH_API.BLACKBOARD_FORMAT]: StoreName.BLACKBOARD_FORMAT,
  [PATH_API.BLACKBOARD_FRAME]: StoreName.BLACKBOARD_FRAME,
  [PATH_API.PIN_CONTENT_IMAGE]: StoreName.PIN_CONTENT_IMAGE,
};

export const DOCUMENT_CATEGORIES = "document-categories";

export enum Operation {
  Post, // POST
  Delete,
  Patch, // PUT
}

export enum UpdateToOnlineStatus {
  Fail,
  Success,
}

export const URL_NO_CACHE = [
  "/s3-initial-multipart-upload",
  "/s3-complete-multipart-upload",
  "/s3-presigned-url-multipart-upload",
  "/new-websocket/",
  // cause this api using stream
  PATH_API.INSPECTION_INSTANCE,
];

export enum SERVICE_WORKER_EVENTS {
  SKIP_WAITING = "SKIP_WAITING",
  GET_VERSION = "GET_VERSION",
  PAGE_READY = "PAGE_READY",
  UNREGISTER = "UNREGISTER",
  ENABLE_SW = "ENABLE_SW",
  DISABLE_SW = "DISABLE_SW",
}

export const INSTALL_SERVICE_WORKER_TIME_OUT = 60 * 3 * 1000; // 3 minutes
